import { useParams } from 'react-router-dom'
import { getContentBySlug } from '@/data/contentService'
import { SeoHead } from '@/components/seo/SeoHead'
import { caseStudyBlogPath, caseStudyCanonicalPath } from '@/lib/caseStudyPublicUrl'
import { CaseStudyLongPage } from '@/pages/CaseStudyLongPage'
import { NotePage } from '@/pages/NotePage'

type Props = {
  /** When true, page URL is `/blog/:slug` (same content as `/case-studies/:slug`). */
  underBlog?: boolean
}

export const CaseStudyRoutePage = ({ underBlog = false }: Props) => {
  const { slug = '' } = useParams<{ slug: string }>()
  const pathname = underBlog ? caseStudyBlogPath(slug) : caseStudyCanonicalPath(slug)
  const note = underBlog && slug ? getContentBySlug('note', slug) : undefined
  const post = slug ? getContentBySlug('case-study', slug) : undefined

  if (note?.type === 'note') {
    return <NotePage post={note} pathname={pathname} />
  }

  if (!post || post.type !== 'case-study' || (underBlog && post.visibility === 'private')) {
    return (
      <>
        <SeoHead pathname={pathname} kind="not-found" />
        <div className="site-page mx-auto max-w-lg px-6 pt-0 pb-24 text-center md:py-24">
          <h1 className="font-display text-2xl font-semibold text-[var(--foreground)]">Case study not found</h1>
          <p className="mt-3 text-[var(--foreground-muted)]">No content for “{slug}”.</p>
          <a
            href="/"
            className="mt-8 inline-block text-sm font-semibold text-[var(--foreground)] underline underline-offset-2"
          >
            Back home
          </a>
        </div>
      </>
    )
  }

  return <CaseStudyLongPage data={post} pathname={pathname} />
}
